import React, {PureComponent as Component} from 'react';

import FormManager from "../../../ui/template/Form/FormManager";
import Submit from "../../../ui/template/Form/Submit";
import Alerts from "../../../ui/template/Alert/Alerts";
import InputPassword from "../../../ui/template/Input/InputPassword";
import setPasswordApi from "./Api/setPassword";
import {X,Check} from "react-feather";
import {MCbrowser} from "../../Context/browserContext";


class  Password extends Component{

    constructor(props) {
        super(props);
        this.HoldPasswordChange = this.oldPasswordChange.bind(this);
        this.HpasswordChange = this.passwordChange.bind(this);
        this.handlePostUp = this.postUp.bind(this);
        this.state = {loaded: false };
        this.values = {  oldPassword: '',password: '' };
        this.form1=React.createRef();
        this.formAlerts=React.createRef();
        this.props=props;
    }


    oldPasswordChange(e) {
        this.values.oldPassword= e.target.value;
        return true;
    }

    passwordChange(e) {
        this.values.password= e.target.value;
        return true;
    }


    async postUp() {
        let pageAlerts = this.context.page.pageAlerts;
        let l=await setPasswordApi(this.values.oldPassword,this.values.password,pageAlerts,this.formAlerts);
        if(l===true){

        }
    }

    componentDidMount() {
        this.setState({loaded: true });
    }


    render() {
        return (
            <React.Fragment>
                <FormManager ref={this.form1} submit={this.handlePostUp}>
                <div className="modal fade" id="passwordModal" tabIndex="-1" role="dialog"
                     aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    تغییر
                                    گذرواژه
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <X />
                                </button>
                            </div>
                            <div className="modal-body">

                                    <div className="form-group">
                                        <label htmlFor="recipient-name" className="col-form-label">
                                            گذرواژه
                                            فعلی
                                            :</label>
                                        <InputPassword className="form-control" onChange={this.HoldPasswordChange}/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="message-text" className="col-form-label">
                                            گذرواژه
                                            جدید
                                            :</label>
                                        <InputPassword  className="form-control" onChange={this.HpasswordChange}/>
                                    </div>
                                    <Alerts layout="relative" ref={this.formAlerts} />

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                    بستن
                                </button>
                                <Submit className="btn btn-primary">
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    ثبت
                                    <Check size={16} className="ml-2" />
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                </Submit>
                            </div>
                        </div>
                    </div>
                </div>
                </FormManager>
            </React.Fragment>
        );
    }
}

Password.contextType = MCbrowser;

export default Password;
